module.exports = __webpack_public_path__ + "static/img/3-noinfo-product-library.8921c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/3-noinfo-product-library.png
// module id = 1333
// module chunks = 0